export interface IPaginatedQueryParams {
    page: string;
    size: string;
    direction: string;
    sort: string | string[];
}
